import { BillType, IBaseQueryParameters, SortType } from '../index.js'

/**
 * This interface defines the query parameters for the endpoints available in
 * the `Bills` endpoint class.
 */
export interface IBillsQueryParameters extends IBaseQueryParameters {
  /** Start timestamp to filter by update date. */
  fromDateTime?: string

  /** End timestamp to filter by update date. */
  toDateTime?: string

  /** Sort by `updateDate` in ascending (`asc`) or descending (`desc`) order. */
  sort?: SortType
}

/**
 * This interface defines the path parameters for the endpoints available in the
 * `Bills` endpoint class.
 */
export interface IBillsPathParameters {
  /** The congress number. For example, the value can be `117`. */
  congress?: number

  /**
   * The type of bill. Value can be `hr`, `s`, `hjres`, `sjres`, `hconres`,
   * `sconres`, `hres`, or `sres`.
   */
  billType?: BillType

  /** The bill’s assigned number. For example, the value can be `3076`. */
  billNumber?: number
}
